/**
 * @module $Name$
 * Container Component for RisksItem
 */
import React, {useMemo, useState} from 'react';
import styled from 'styled-components';
import TextAreaEditorWrapper from '../../../TextAreaEditor/TextAreaEditor';
import {currentResource, labels} from '../../../../../util/utils';

export default function RisksItem(props) {
	const {riskType, onItemChange} = props;
	const [risk, setRisk] = useState({riskTypeId: riskType});
	const riskTypes = currentResource.riskTypes;
	const displayRiskNameError = '';

	const handlerOnRiskNameChange = (e) => {
		let newRisk = {...risk, riskName: e.target.value};
		setRisk(newRisk);

		onItemChange && onItemChange(newRisk);
	};

	const riskNameInput = (
		<section title={risk?.riskName} className="riskname-input">
			<TextAreaEditorWrapper
				key={'riskName' + risk?.id}
				textAreaEditorLabel={labels.riskDescriptionLabel}
				placeholder={''}
				value={risk.riskName}
				maxLength={500}
				showCounter
				onChange={(e) => {
					handlerOnRiskNameChange(e);
				}}
				textAreaError={displayRiskNameError}
				textAreaErrorMessage={labels.requiredRiskName}
			/>
		</section>
	);

	const riskTypeLabel = useMemo(() => {
		return <h1 className="RiskTypesH1">{riskTypes.find((rt) => rt.id === riskType)?.title}</h1>;
	}, [riskTypes]);

	return (
		<StyledRisksItem className={`StyledRisksItem RiskTypeLabelAvailable`}>
			<>
				{riskTypeLabel}
				{riskNameInput}
			</>
		</StyledRisksItem>
	);
}

RisksItem.defaultProps = {
	showRiskTypeLabel: false
};

const StyledRisksItem = styled.li`
	display: flex;
	flex-direction: row;
	&.RiskTypeLabelAvailable {
		flex-direction: column;
		.RiskTypesH1 {
			margin: 0 var(--px-10) var(--px-10) 0;
		}
		.riskname-input {
			width: 100%;
		}
	}
	.riskname-input {
		width: 60%;
		margin-right: var(--px-20);
		.motif-form-field-text-input .motif-input-component .motif-text-area {
			min-height: var(--px-210);
		}
	}
	.risk-controls {
		width: 10%;
		padding-left: var(--px-20);
		padding-top: var(--px-10);
	}
`;
